<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="app">
        <br />
        <h3 class="title cor-preta" :style="{ color: corTexto }">
          Produto selecionado:
        </h3>
        <div>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Produto</b></label
                    >
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Preço</b></label
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>{{ product.nm }}</b></label
                    >
                  </td>
                  <td>
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>R$ {{ total }}</b></label
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-md-14">
            <div>
              <label class="cor-preta" :style="{ color: corTexto }"
                ><b>Escolha os sabores</b></label
              ><br />
            </div>
          </div>

          <div class="col-md-14">
            <div v-if="product.qtd >= '0'">
              <label class="cor-preta" :style="{ color: corTexto }"
                ><b class="letra-pequena"
                  >Você pode selecionar {{ product.qtd }} sabores.</b
                ></label
              ><br />
            </div>
            <div v-else>
              <label class="cor-preta" :style="{ color: corTexto }"
                ><b class="letra-pequena"
                  >Selecione quantos sabores você quiser.</b
                ></label
              ><br />
            </div>
          </div>

          <div id="listandoordem">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Opções</b></label
                    >
                  </th>
                  <th v-if="tipo != '1'" scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Preço</b></label
                    >
                  </th>
                  <th v-if="tipo != '0'" scope="col" colspan="3">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b> Quantidade</b></label
                    >
                  </th>
                  <th v-else scope="col" colspan="3">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b></b
                    ></label>
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="(sabor, idx) of sabores"
                :key="sabor.cd"
                style="padding: 0.5rem 0 0 0"
              >
                <tr>
                  <td style="padding: 0 0 0 0.5rem; vertical-align: middle">
                    <div style="display: flex; flex-direction: row">
                      <input
                        @change="ativaQtd(idx)"
                        type="checkbox"
                        :id="sabor"
                        :value="sabor"
                        v-model="checkedNames"
                      />
                      <p
                        style="margin-left: 5px; vertical-align: middle"
                        class="cor-preta quebraLinha"
                        :style="{ color: corTexto }"
                      >
                        <b>{{ sabor.nm }}</b>
                      </p>
                    </div>
                  </td>
                  <td
                    style="
                      padding: 0.5rem 0.25rem;
                      text-align: center;
                      vertical-align: middle;
                    "
                    v-if="tipo != '1'"
                    :style="{ color: corTexto }"
                  >
                    R$ {{ retornaValorSabor(sabor.vl) }}
                  </td>
                  <td
                    style="
                      padding: 0.5rem 0.25rem;
                      text-align: center;
                      vertical-align: middle;
                    "
                  >
                    <button @click="menosqtd(sabor, idx)" class="btn btn-dark">
                      -
                    </button>
                  </td>
                  <td
                    style="
                      padding: 0.5rem 0.25rem;
                      text-align: center;
                      vertical-align: middle;
                    "
                  >
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>{{ sabor.qtd }}</b>
                    </label>
                  </td>
                  <td
                    style="
                      padding: 0.5rem 0.25rem;
                      text-align: center;
                      vertical-align: middle;
                    "
                  >
                    <button @click="somarqtd(sabor, idx)" class="btn btn-dark">
                      +
                    </button>
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <div style="display: flex">
                      <img
                        v-if="imagemSabor == '1'"
                        style="
                          max-width: 80px;
                          max-height: 80px;
                          width: 80px;
                          height: 80px;
                        "
                        :src="urlImage(sabor.nm)"
                        @error="erroImagem($event)"
                      />
                      <label
                        style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        "
                        :style="{ color: corDescricao }"
                        >{{ sabor.ingredientes }}</label
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <table border="0">
          <thead>
            <tr>
              <td width="350" valign="top">
                <li align="left">
                  <button
                    style="background-color: #dc3545"
                    @click="voltar()"
                    type="button"
                    class="btn btn-dark"
                  >
                    Voltar
                  </button>
                </li>
              </td>
              <td width="100">
                <li align="center"></li>
              </td>
              <td width="480" valign="top">
                <li align="right">
                  <button
                    style="background-color: #006400"
                    @click="continuar()"
                    type="button"
                    class="btn btn-dark"
                  >
                    Continuar
                  </button>
                </li>
              </td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.table td {
  border: none;
}
.table th:hover {
  background-color: #fff;
}
@media (max-width: 500px) {
  .quebraLinha {
    max-width: 110px;
  }
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Sabor from "../services/sabor";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import Ordem from "../services/nome_ordem";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "PerguntasPizza",
  data() {
    return {
      obs: [],
      product: [],
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao: "",
      },
      adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      corBotao: "",
      corTexto: "",
      corFundo: "",
      corDescricao: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      sabores: [],
      tipo: "",
      imagemSabor: "",
      contrato: "",
    };
  },
  computed: {
    total() {
      var valor = 0;
      var arrayAux = JSON.parse(JSON.stringify(this.checkedNames));

      if (arrayAux.length == 0) {
        return "0.00";
      } else {
        var valorAux = 0;
        if (this.tipo === "3") {
          arrayAux.forEach((sabor) => {
            sabor.vl = parseFloat(sabor.vl);

            if (sabor.vl >= valorAux) {
              valorAux = sabor.vl;
              sabor.vl = 0;
            } else {
              sabor.vl = 0;
            }
          });
          arrayAux[0].vl = valorAux;
        } else if (this.tipo === "2") {
          var i = 0;
          arrayAux.forEach((sabor) => {
            valorAux = valorAux + parseFloat(sabor.vl) * parseInt(sabor.qtd);
            sabor.vl = 0;
            i = i + parseInt(sabor.qtd);
          });
          arrayAux[0].vl = valorAux / i;
        } else if (this.tipo === "1") {
          arrayAux.forEach((sabor) => {
            sabor.vl = 0;
          });
          arrayAux[0].vl = this.product.vl;
        }
        valor = parseFloat(arrayAux[0].vl).toFixed(2);
        return valor;
      }
    },
    ...mapGetters({
      //adicionais: 'allAdicionais',
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    voltar() {
      this.$router.push("/");
    },
    listarContrato() {
      this.contrato = localStorage.getItem("contrato");
    },
    continuar() {
      if (this.checkedNames.length == 0) {
        Swal.fire({
          title: "Escolha ao menos 1 sabor",
          confirmButtonColor: "#000000",
        });
      } else if (this.product.qtd < this.checkedNames.length) {
        Swal.fire({
          title:
            "Você pode selecionar no máximo " +
            this.product.qtd +
            " sabor(es).",
          confirmButtonColor: "#000000",
        });
      } else {
        var valorAux = 0;
        if (this.tipo === "3") {
          this.checkedNames.forEach((sabor) => {
            sabor.vl = parseFloat(sabor.vl);

            if (sabor.vl >= valorAux) {
              valorAux = sabor.vl;
              sabor.vl = 0;
            } else {
              sabor.vl = 0;
            }
          });
          this.checkedNames[0].vl = valorAux;
        } else if (this.tipo === "2") {
          var i = 0;
          this.checkedNames.forEach((sabor) => {
            valorAux = valorAux + parseFloat(sabor.vl) * parseInt(sabor.qtd);
            sabor.vl = 0;
            i = i + parseInt(sabor.qtd);
          });
          this.checkedNames[0].vl = valorAux / i;
        } else if (this.tipo === "1") {
          this.checkedNames.forEach((sabor) => {
            sabor.vl = 0;
          });
          this.checkedNames[0].vl = this.product.vl;
        }

        this.checkedNames[0].tipo = "PIZZA";

        for (let i = 0; i < this.checkedNames.length; i++) {
          this.checkedNames[i].pizza = true;
        }

        this.adicionaispergunta = JSON.parse(JSON.stringify(this.checkedNames));

        this.adicionaispergunta.forEach((adicional) => {
          if (adicional.qtd > 1) {
            adicional.nm = `${adicional.qtd}x ${adicional.nm}`;
          }
        });

        ls.set(
          "sabores" + localStorage.getItem("contrato"),
          JSON.parse(JSON.stringify(this.checkedNames))
        );
        this.NextScreen(this.product, this.adicionaispergunta, this.obs);
      }
    },
    NextScreen(product, adicionaispergunta, obs) {
      Ordem.verificaordem(product.cd).then((response) => {
        if (response.data != null) this.$router.push("/perguntas");
        else {
          product.vl = 0;
          this.$store.dispatch("addToCart", {
            product,
            adicionaispergunta,
            obs,
          });
          this.$router.push("/cart");
        }
      });
    },
    listarSabores() {
      this.product = ls.get("product" + localStorage.getItem("contrato"));
      Sabor.verificasabor(this.product.cd).then((resposta) => {
        this.sabores = resposta.data.filter((sabor) => {
          sabor.qtd = 0;
          return sabor.ativo == "1";
        });
      });
    },
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
    },
    menosqtd(sabor, index) {
      if (this.sabores[index].qtd >= 1) {
        this.sabores[index].qtd -= 1;
        if (this.sabores[index].qtd == 0) {
          this.checkedNames = this.checkedNames.filter((sb) => {
            if (sb.cd != sabor.cd) {
              return sb;
            }
          });
        }
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
      }
    },

    quantidadeDeSabores(sabores) {
      var quantidade = 0;
      sabores.forEach((sabor) => {
        quantidade = quantidade + sabor.qtd;
      });
      return quantidade;
    },
    retornaValorSabor(sabor) {
      sabor = parseFloat(sabor).toFixed(2).replace(".", ",");
      return sabor;
    },

    somarqtd(sabor, index) {
      if (this.quantidadeDeSabores(this.checkedNames) < this.product.qtd) {
        if (this.sabores[index].qtd == 0) {
          this.checkedNames.push(sabor);
        }
        this.sabores[index].qtd += 1;
      } else {
        Swal.fire({
          title: `Limite de sabores é ${this.product.qtd} .`,
          confirmButtonColor: "#000000",
        });
      }

      //alert(JSON.stringify(index));
    },
    ativaQtd(index) {
      if (this.sabores[index].qtd == 0) {
        this.sabores[index].qtd = 1;
      } else {
        this.sabores[index].qtd = 0;
      }
    },
    listandoInis() {
      var cd = "PIZZA";
      Inis.listarInisCd(cd).then((resposta) => {
        this.tipo = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "COR_DESCRICAO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((response) => {
        var idPixel = response.data[0].vl;
        if (idPixel != "") {
          this.loadFacebookPixel(idPixel);
        }
      });
    },
    loadFacebookPixel(idPixel) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=" +
        idPixel +
        "&ev=ViewContent&noscript=1";

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    listandoInisImagemSabor() {
      var cd = "IMAGEM_SABOR";
      Inis.listarInisCd(cd).then((resposta) => {
        this.imagemSabor = resposta.data[0].vl;
      });
    },
    urlImage(sabor) {
      let encodedNm = Buffer.from(sabor).toString("base64");
      return `https://apppanterafood.com.br/DeliCenter/${
        this.contrato
      }/sabores/${encodedNm}.jpg?${performance.now()}`;
    },
    erroImagem(event) {
      event.target.src = `https://apppanterafood.com.br/DeliCenter/${this.contrato}/sabores/sem_imagem_sabores.jpg`;
    },

    ...mapActions(["addToCart"]),
  },
  mounted() {
    /* this.listarproduto(); */
    this.listandoInis();
    this.listarinis();
    this.listarSabores();
    this.listandoInisImagemSabor();
    this.listarContrato();
  },
};
</script>
